import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private router = inject(Router);
  private msalBroadcastService = inject(MsalBroadcastService, { optional: true });
  private readonly _destroying$ = new Subject<void>();

  useMockAuth = environment.useMockAuth;
  mockUserName = '';
  mockUserEmail = '';
  isLoggingIn = false;

  ngOnInit() {
    if (this.useMockAuth) {
      const account = this.authService.getActiveAccount();
      this.mockUserName = account?.name || 'Development User';
      this.mockUserEmail = account?.username || 'dev@localhost.com';
    } else {
      // Subscribe to authentication state changes
      this.authService.isAuthenticated$
        .pipe(takeUntil(this._destroying$))
        .subscribe((isAuthenticated) => {
          if (isAuthenticated) {
            // Redirect to home when user successfully logs in
            this.router.navigate(['/']);
          }
        });

      // Track interaction status to disable button during login
      if (this.msalBroadcastService) {
        this.msalBroadcastService.inProgress$
          .pipe(
            filter((status: InteractionStatus) => status !== InteractionStatus.Startup),
            takeUntil(this._destroying$)
          )
          .subscribe((status: InteractionStatus) => {
            this.isLoggingIn = status !== InteractionStatus.None;
          });
      }
    }
  }

  login() {
    if (this.isLoggingIn) {
      return;
    }
    this.authService.login();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
